import { type RefObject, useEffect, useRef } from "react";

export function useOnClickOutside<T extends HTMLElement>(
	ref: RefObject<T | null>,
	handler: (event: MouseEvent) => void,
	enabled = true,
) {
	const handlerRef = useRef(handler);
	handlerRef.current = handler;

	useEffect(() => {
		if (!enabled) return;
		const listener = (event: MouseEvent) => {
			const el = ref.current;
			if (!el || !(event.target instanceof Node) || el.contains(event.target)) return;
			handlerRef.current(event);
		};
		document.addEventListener("mousedown", listener);
		return () => document.removeEventListener("mousedown", listener);
	}, [ref, enabled]);
}
